// 派送方式相关 getters
import calc from 'calculatorjs'
import { computeLimitKtj } from '@g/order-create/carrier/limitKtj'
import { computeFirstCarrier } from '@g/utils/orderUtils'
import { calcHctCai, limitHctLandAddr } from '@g/utils/parcelUtils'
import { computeSedeFee } from '@g/utils/sedeFeeUtils'

export const getters = {
  jyoCarrierCanUseToHome (state) {
    // 是否可以使用宅配
    const prepareModel = state.createPrepare
    if (prepareModel.parcelsInfo.jyAddrid === '1596') {
      // 5kg以下不能選擇宅配
      if (prepareModel.parcelsInfo.jyWeight < 1500) {
        // return false
      }
    }
    return true
  },
  jyoCarrierCanUse711 (state, getters) {
    // 是否可以使用711
    const shippingRatesInfo = getters.shippingRatesInfo
    if (shippingRatesInfo.srLabel === 'HZKZQ') {
      return false
    }
    const prepareModel = state.createPrepare
    if (getters.isCompanyAddr) {
      return false
    }

    return true
  },
  show711Radio (state, getters) {
    const addrInfo = state.currAddrInfo
    const shippingRatesInfo = getters.shippingRatesInfo
    const prepareModel = state.createPrepare
    if (!prepareModel) return false

    // 學生地址優惠不適用超商取貨
    if (prepareModel.shippingRates?.some(sr => sr.parcelsFeeFormulas?.cneeAddressDiscount)) {
      return false
    }

    let srCanUse711 = shippingRatesInfo.transport === 'air' ||
      (prepareModel.parcelsInfo.jyAddrid === '1592' && shippingRatesInfo.srLabel === 'ECONOMY-ALL') // 超商加在經濟型海快上
    if (shippingRatesInfo.memo?.jyoCarrier?.includes('7-11') && shippingRatesInfo.srLabel !== 'CB1688') {
      srCanUse711 = true
    }

    return addrInfo && srCanUse711 && getters.jyoCarrierCanUseToHome
  },
  carrier711Error (state) {
    const prepareModel = state.createPrepare

    if (
      prepareModel.parcels.find((parcel) => {
        // 1. 長+寬+高≦105公分<br>
        // 2. 單邊長≦45公分、其他兩邊≦30公分
        const lengthArr = [
          parcel.length / 10,
          parcel.width / 10,
          parcel.height / 10,
        ]
        lengthArr.sort((a, b) => b - a)
        if (lengthArr.reduce((a, b) => a + b, 0) > 105) {
          return true
        }
        if (lengthArr[0] > 45 || lengthArr[1] > 30) {
          return true
        }
        return false
      })
    ) {
      return '材積超過超商店配限制'
    }
    if (prepareModel.parcelsInfo.jyWeight > 9500) {
      return '重量超過超商店配限制'
    }

    if (prepareModel.parcelsInfo?.jyParcelBiz > 0 || prepareModel.parcelsInfo?.jyParcelBizTakao > 0) {
      return '商業件無法從高雄清關，因此無法使用711'
    }

    return ''
  },
  canVan (state, getters) {
    // 1 海快才能自派件
    // 2 自取件不能自派件
    // 3 只有  東莞 跟 漳州 有自派件
    // 4 只支持台北市,臺北市,新北市,桃園市,基隆市,新竹市,新竹縣,台中市,臺中市,彰化縣,南投縣
    // 5 只支持 yuguan jetf 报关行

    // 有棧板費的包裹 或者快递包裹滿足以下其中一個的条件
    // 1才及以上的包裹大於等於20件
    // 2才及以上的包裹大於等於10件
    // 4才及以上的包裹大於等於5件

    const prepare = state.createPrepare

    // 1 海快才能自派件
    if (getters.shippingRatesInfo.transport !== 'se') {
      return false
    }

    // 2 自取件不能自派件
    if (getters.shippingRatesInfo.srLabel === 'HZKZQ') {
      return false
    }

    // 当前是報關行 是 宇冠或捷豐 才有专车派件
    if (!['yuguan', 'jetf'].includes(prepare.lcmrouteSe?.twcc?.provider)) {
      return false
    }

    // 3 只有  東莞 跟 漳州 有自派件
    const jyAddrid = prepare.parcelsInfo.jyAddrid
    if (jyAddrid !== '2769' && jyAddrid !== '1596') {
      return false
    }

    // 4 只支持台北市,臺北市,新北市,桃園市,基隆市,新竹市,新竹縣,台中市,臺中市,彰化縣,南投縣
    const addrInfo = state.currAddrInfo
    const citys = ['台北市', '臺北市', '新北市', '桃園市', '基隆市', '新竹市', '新竹縣', '台中市', '臺中市', '彰化縣', '南投縣']
    if (!addrInfo || !citys.includes(addrInfo.city)) {
      return false
    }

    // 有棧板費的包裹可以使用专车派件
    if (getters.hasHctHatPalletFeeParcels.length > 0) {
      return true
    }

    // 或者快递包裹满足以下其中一个条件：
    // 1才及以上的包裹大於等於20件
    // 2才及以上的包裹大於等於10件
    // 4才及以上的包裹大於等於5件
    const parcels1Cai = prepare.parcels.filter(parcel => parcel.hctCaiNoCeil >= 1)
    const parcels2Cai = prepare.parcels.filter(parcel => parcel.hctCaiNoCeil >= 2)
    const parcels4Cai = prepare.parcels.filter(parcel => parcel.hctCaiNoCeil >= 4)
    console.log(parcels1Cai.length, parcels2Cai.length, parcels4Cai.length)
    if (parcels1Cai.length >= 20 || parcels2Cai.length >= 10 || parcels4Cai.length >= 5) {
      return true
    }

    return false
  },
  vanFee (state, getters) {
    const prepare = state.createPrepare

    if (!getters.canVan) {
      return 0
    }

    const palletFee = getters.hasHctHatPalletFeeParcels.length * getters.oneHctPalletFee
    if (palletFee > 0) {
      // 专车费用使用  jyorder-create/prepare hctCitiesPalletFee 参数计算，max(floor(栈板费*0.8), 2500)
      return Math.min(Math.floor(palletFee * 0.8), 2500)
    }
    return 0
  },
  limitHct (state, getters) {
    const prepareModel = state.createPrepare
    const shippingRatesInfo = getters.shippingRatesInfo
    const addrInfo = state.currAddrInfo
    if (shippingRatesInfo.transport === 'air' && prepareModel.parcels.find(item => {
      return calc(`${item.height / 10}+${item.length / 10}+${item.width / 10}`) > 180
    })) {
      return true
    }
    if (addrInfo && addrInfo.isLandAddr) {
      // 自取不限制
      if (shippingRatesInfo.srLabel === 'HZKZQ') return false
      // 连江县限制
      if (addrInfo.city === '連江縣') {
        if (prepareModel.parcels.find(item => {
          const length = item.length / 10
          const width = item.width / 10
          const height = item.height / 10
          if (Math.max(length, width, height) >= 100) return true
          if (length + width + height >= 150) return true
          if (item.weight >= 20000) return true
          const cai = length * width * height / 27000
          return cai >= 2
        })) {
          return 'landLimit'
        }
      } else if (prepareModel.parcels.find(item => limitHctLandAddr(item))) {
        return 'landLimit'
      }
    }
    return false
  },
  limitTy (state, getters) {
    return !!(state.currAddrInfo && state.currAddrInfo.city === '連江縣')
  },
  limitTcat (state, getters) {
    return !!getters.hasWoodenParcels
  },
  hasHctPallet (state, getters) {
    return (finalUseFirstCarrier) => {
      return finalUseFirstCarrier === 'hct' && state.createPrepare.parcels.find(item => calcHctCai(item) >= 8) != null
    }
  },
  hzkzqWeightLimit (state, getters) {
    if (getters.shippingRatesInfo.srLabel !== 'HZKZQ') return false
    if (Number(getters.shippingRatesInfo.srTwAddrid) === 3209) return false
    if (state.createPrepare.parcelsInfo.jyAddrid === '1592') {
      return !!state.createPrepare.parcels.find(parcel => parcel.weight > 30000)
    }
    return !!state.createPrepare.parcels.find(parcel => parcel.weight > 40000)
  },
  getFirstCarrierBy: (state, getters) => ({ addrInfo, csType, isBusiness, estimateWeight }) => {
    if (!state.createPrepare) return ''
    const prepareModel = state.createPrepare
    const rawWeight = prepareModel.parcelsInfo.jyWeight
    const jyoChgWeight = estimateWeight === undefined
      ? rawWeight
      : (rawWeight > 0 ? rawWeight : estimateWeight)
    return computeFirstCarrier({
      jyoChgWeight,
      parcels: prepareModel.parcels,
      jyoCneeAddress: addrInfo,
      isLandAddr: getters.otherFees.landFee > 0,
      isBusiness,
      jyoSrTransport: getters.shippingRatesInfo.transport,
      csType,
      jyAddrid: prepareModel.parcels[0].jyAddrid,
    })
  },
  limitKtjBy: (state, getters) => ({ strategy, transport }) => {
    return computeLimitKtj({
      strategy,
      parcelAddrid: state.createPrepare.parcels[0].jyAddrid,
      parcels: state.createPrepare.parcels,
      transport,
    })
  },
  // 計費重量0kg：每筆訂單加收100元派件費
  // 計費重量1kg ~ 4.5kg：每筆訂單加收80元派件費
  // 計費重量5kg（含）以上：免派件費
  // sr 级静态过滤已在预处理阶段写入 sr.parcelsFeeFormulas.sedeAddls
  // 这里只保留依赖 jyoCarrier 的动态分支，需按 finalSr 调用
  sedeFeeOf: (state) => (sr) => {
    return computeSedeFee(sr?.parcelsFeeFormulas?.sedeAddls, state.createForm.jyoCarrier)
  },
}
